"use client"

import { useState, useEffect, useCallback } from 'react'
import Icon from '@components/shared/Icon'
import useT from '@hooks/useTranslation'
import withUser from '@hoc/withUser'
import useRedirectBack from '@hooks/useRedirectBack'
import { get, post } from '@api/apiFetcher'
import { LOGIN_PAGE } from '@constants/routes'

import styles from 'styles/OfferWatch.module.css'

const test = process.env.NODE_ENV != 'production'

// isLoggedIn
const Watch = ({ iconStyle, user, offer: { _user, type, _id: _ad } = {}, showText = false }) => {
    const { _id, token } = user || {}
    const userId = _user?._id || _user
    const isOwner = test ? false : _id === userId

    const [redirect, setRedirect] = useRedirectBack()
    const [isWatched, setIsWatched] = useState(false)
    const getPath = useCallback(() => `/api/offers/${type}/${_ad}/watch`, [type, _ad])
    const path = getPath()

    useEffect(() => {
        if (!token) return
        get({ path, auth: token })
            .then(res => setIsWatched(res.on))
            .catch(err => console.log(err))
    }, [_id, _ad, path, token])

    const onClick = token
        ? (e) => {
            e.preventDefault()
            post({ path, auth: token })
                .then(res => setIsWatched(res.on))
                .catch(err => console.log(err))
          }

        : () => {
            setRedirect()
            redirect(LOGIN_PAGE)
          }

    const obserwuj = useT('Obserwuj ogłoszenie')
    const obserwujesz = useT('Obserwujesz ogłoszenie')
    const look = isWatched
        ? { class: `${styles.active}`, icon: 'thumb_up_alt', text: obserwujesz }
        : { icon: 'thumb_up_off_alt', text: obserwuj }

    return isOwner
        ? null
        : (
            <span icon="true" onClick={onClick} role="button">
                <Icon className={look.class} style={iconStyle}>{look.icon}</Icon>
                { showText && <span>{look.text}</span> }
            </span>
          )
}

export default withUser(Watch)